import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { IAppState } from 'src/app/state/app.state';
import { reviewPageReducer } from '../views/ccm/state/review-page.reducer';
import { rpmPageReducer } from '../views/rpm/state/rpm-page.reducers';

export const reducers: ActionReducerMap<IAppState> = {
    rpmPage: rpmPageReducer,
    reviews: reviewPageReducer
}

export const metaReducers: MetaReducer<IAppState>[] = [];